<template>
  <div class="reviewBox">
    <div class="studentTime" v-for="studentTime in studentTimes" :key="studentTime.student.id">
      <b-row>
        <b-col cols="8" md="9">
          <b-row>
            <b-col md="4">{{ studentTime.student.firstName }} {{ studentTime.student.lastName}}</b-col>
            <b-col md="8"><b>{{studentTime.time}}</b></b-col>
          </b-row>
        </b-col>
        <b-col cols="4" md="3" class="d-flex flex-column"  v-if="shouldShowChange">
          <b-button
              class="changeBtn" @click="handleChangeButtonClicked(studentTime.student)" size="sm" variant="outline-secondary">CHANGE</b-button>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewStudentTimes",
  props: {
    'studentTimes': {type: Array},
    'shouldShowChange': {type: Boolean},
  },
  setup(props, {emit}) {
    function handleChangeButtonClicked(student) {
      emit('change-clicked', student);
    }
    return {
      handleChangeButtonClicked
    }
  }
}
</script>

<style scoped>

.reviewBox {
  border: 1px solid #595959;
  padding: 1rem;
}
.studentTime {
  margin-top: .75rem;
  font-size: 1rem;
}
.studentTime:first-of-type {
  margin: 0;
}
.changeBtn {
  width: 100%;
  color: #595959;
  border-color: #595959;
  /* full height btn*/
  flex: 1 1 auto;
}

</style>